import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuloFiscalLayout from './ModuloFiscalLayout';
import ModuloFiscalDashboardPage from './ModuloFiscalDashboardPage';
import ModuloFiscalContratosPage from './ModuloFiscalContratosPage';
import ModuloFiscalContratoDetalhePage from './ModuloFiscalContratoDetalhePage';
import ModuloFiscalNotasFiscaisPage from './ModuloFiscalNotasFiscaisPage';
import ModuloFiscalProcessoAdministrativoPage from './ModuloFiscalProcessoAdministrativoPage';
import ModuloFiscalContratacaoWizardPage from './ModuloFiscalContratacaoWizardPage';
import ModuloFiscalProcessoDetalhePage from './ModuloFiscalProcessoDetalhePage';

/** Módulo isolado do fiscal — shell próprio (padrão Jurídico/ARCA). */
export default function ModuloFiscalModule() {
  return (
    <Routes>
      <Route path="/modulos/fiscal/:fiscalId" element={<ModuloFiscalLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ModuloFiscalDashboardPage />} />
        <Route path="contratos" element={<ModuloFiscalContratosPage />} />
        <Route path="contratos/:contratoId" element={<ModuloFiscalContratoDetalhePage />} />
        <Route path="notas-fiscais" element={<ModuloFiscalNotasFiscaisPage />} />
        <Route path="processo-administrativo" element={<ModuloFiscalProcessoAdministrativoPage />} />
        <Route
          path="processo-administrativo/contratacao"
          element={<ModuloFiscalContratacaoWizardPage />}
        />
        <Route
          path="processo-administrativo/:processoId"
          element={<ModuloFiscalProcessoDetalhePage />}
        />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
}
